"use strict";

import Phaser from 'phaser';

export default class extends Phaser.GameObjects.Group {
  static get STEM_FRAME() {
    return 0;
  }

  static get LEAF_FRAMES() {
    return [1, 2, 3, 4];
  }

  static get STEM_GROWTH() {
    return 2;
  }

  static get STEM_SPRITE_HEIGHT() {
    return 2;
  }

  get top() {
    return { x: this.stemDetails.x, y: this.stemDetails.y };
  }

  constructor(config) {
    super(config.scene);

    this.rnd = config.rnd;
    this.head = null;
    this.scene.add.existing(this);
    this.active = false;

    this.stemDetails = { lastScore: 0, x: 0, y: 0, height: 0 };
    this.leafDetails = { lastScore: 0, lastDir: -1 };
    this.leaves = [];

    // x, y, width, height, textureKey, textureFrame
    this.stem = this.scene.add.tileSprite(0, 0, 0, 0, 'stem');
    this.stem.setDepth(100);
    this.stem.setOrigin(0.5, 1);
    this.stem.visible = false;
    this.add(this.stem);

    this._events = new Phaser.Events.EventEmitter();
  }

  on(eventName, handler, context) {
    this._events.on(eventName, handler, context);
  }

  // Called when seed has been planted. Called once.
  grow(x, y) {
    this.active = true;
    this.stemDetails.x = x;
    this.stemDetails.y = y - this.constructor.STEM_SPRITE_HEIGHT;
    this.stemDetails.height = this.constructor.STEM_SPRITE_HEIGHT;
    this.y = y;
    this.x = x;

    this.stem.visible = true;
    this.stem.x = x;
    this.stem.y = y - 4;
  }

  growStem(times = 1) {
    let x = null;
    let y = null;
    let didGrow = false;
    let growAmount = 0;
    let oldHeight = Math.abs(this.stem.height);

    for (let i = 0; i < times * this.constructor.STEM_GROWTH; i++) {
      this.stemDetails.y -= this.constructor.STEM_SPRITE_HEIGHT;
      this.stemDetails.height += this.constructor.STEM_SPRITE_HEIGHT;

      this.stem.height += this.constructor.STEM_SPRITE_HEIGHT;
      didGrow = true;
    }

    if (didGrow) {
      this._events.emit('growing', this.x, this.stemDetails.y);
    }
  }

  addLeaf() {
    let x = this.stemDetails.x;
    let y = this.stemDetails.y;
    // pick left or right;
    this.leafDetails.lastDir *= -1;
    let newLeaf = this.create(x, y, 'plant', this.constructor.LEAF_FRAMES[0]);
    newLeaf.setOrigin(0.5, 1);
    newLeaf.angle = 90;

    if (this.leafDetails.lastDir <= 0) {
      newLeaf.angle = -90;
      newLeaf.flipX = true;
    }
    this.leaves.push(newLeaf);
  }

  update(config) {
    let score = config.score;
    this.updateGrowth(score);
    this.updateLeaves(score);
  }

  updateGrowth(score) {
    let scoreDelta = score - this.stemDetails.lastScore;
    let growDelta = 10;
    let growth = Math.floor(scoreDelta / growDelta);
    if (growth > 0) {
      this.growStem(growth);
      this.stemDetails.lastScore = score;
    }
  }

  updateLeaves(score) {
    let scoreDelta = score - this.leafDetails.lastScore;
    let growDelta = 50;
    let growth = Math.floor(scoreDelta / growDelta);
    if (growth > 0) {
      this.addLeaf();
      this.leafDetails.lastScore = score;
    }
  }

  animateFlower(callback) {
    // add center to top of stem
    this.center = this.create(this.x, this.stemDetails.y - 3, 'plant', 5);
    this.center.setDepth(100);
    this.center.setOrigin(0.5, 0.5);
    this.center.setScale(0.1);
    // grow the center over time
    this.scene.tweens.add({
      targets: this.center,
      scaleX: 1,
      scaleY: 1,
      duration: 1000,
      ease: 'Back',
      onComplete: () => {
        this._growPetals(callback);
      }
    });
  }

  _growPetals(callback) {
    let i = 0;
    let petalCount = 20.0;
    let currentPetal = null;
    let radius = 15 / 2.0;
    let x = 0;
    let y = 0;
    // "angle" is the angle of rotate of the sprite.
    let angle = 0;
    // "rad" is the angle of the sprite (in radians), minus the fixed 90deg rotation required to
    // rotate the sprite texture from straight up and down, to a horizontal position for drawing.
    let rad = 0;
    for (; i < petalCount; i++) {
      // Rotate the texture graphic by 90deg, then evenly place them around the flower's "head"
      angle = 90 + i * (360.0 / petalCount);

      // Get the radians of the above angle, minutes the 90deg correction.
      rad = Math.PI / 180 * (angle - 90);

      // Math.sin/cos require radians, and we will use that for placing the petal around the center "head"
      x = this.center.x + Math.cos(rad) * radius;
      y = this.center.y + Math.sin(rad) * radius;

      currentPetal = this.create(x, y, 'petal');
      currentPetal.setDepth(this.center.depth + 1);
      currentPetal.setScale(0.001);
      currentPetal.setOrigin(0.5, 1);
      currentPetal.setAngle(angle);

      let tweenParams = {
        targets: currentPetal,
        scaleX: 0.75,
        scaleY: 0.75,
        duration: 200,
        ease: 'Back',
        delay: i * 50
      };

      if (i >= petalCount - 1) {
        tweenParams.onComplete = () => {
          this.scene.time.addEvent({ delay: 1500, callback: callback });
        };
      }

      this.scene.tweens.add(tweenParams);
    }
  }
}